module.exports = __webpack_public_path__ + "static/media/logo-facebook-white.e1c93f91.svg";